const applyApplicationsModel = require('./apply-applications.json');
const applyProspectInquiriesModel = require('./apply-prospect-inquiries.json');
const aidApplicationsModel = require('./aid-applications.json');

module.exports = {
    applyApplicationsModel,
    applyProspectInquiriesModel,
    aidApplicationsModel
};
